// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"5dc00adb","885":"805d2c10"}[chunkId] + ".chunk.js";
};